<script setup>
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';

import PageHeader from '../SettingsSubPageHeader.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const store = useStore();

const isSubmitting = ref(false);

const goToFinish = () => {
  router.replace({
    name: 'settings_inbox_finish',
    params: {
      page: 'new',
      inbox_id: route.params.inbox_id,
    },
  });
};

const refreshLabels = async () => {
  await store.dispatch('labels/get');
};

const submit = async ({ classify }) => {
  isSubmitting.value = true;
  try {
    await store.dispatch('inboxes/classifyConversations', {
      inboxId: route.params.inbox_id,
      classify,
    });
    await refreshLabels();
    if (classify) {
      useAlert(t('INBOX_MGMT.ADD.AUTO_LABEL.SUCCESS'));
    }
    goToFinish();
  } catch (error) {
    useAlert(error.message || t('INBOX_MGMT.ADD.AUTO_LABEL.ERROR'));
  } finally {
    isSubmitting.value = false;
  }
};

const skip = () => submit({ classify: false });
const enableAutoLabel = () => submit({ classify: true });
</script>

<template>
  <div class="h-full w-full p-6 col-span-6">
    <PageHeader
      :header-title="t('INBOX_MGMT.ADD.AUTO_LABEL.TITLE')"
      :header-content="t('INBOX_MGMT.ADD.AUTO_LABEL.DESC')"
    />
    <div class="flex flex-wrap gap-2 mt-6">
      <NextButton
        outline
        slate
        :disabled="isSubmitting"
        :label="t('INBOX_MGMT.ADD.AUTO_LABEL.SKIP')"
        @click="skip"
      />
      <NextButton
        solid
        blue
        :is-loading="isSubmitting"
        :label="t('INBOX_MGMT.ADD.AUTO_LABEL.ENABLE')"
        @click="enableAutoLabel"
      />
    </div>
  </div>
</template>
